import { SignJWT } from 'jose';

export default function JtokenRequest(payload) {
    let chave = process.env.REACT_APP_CLIENT_SECRET;
    chave = new TextEncoder().encode(chave);

    return new SignJWT({ codUsuario: payload })
        .setProtectedHeader({ alg: 'HS256' })
        .setExpirationTime('15m')
        .sign(chave)
        .then(token => {
            return token;
        })
        .catch(error => {
            return null;
        });
}
